import { useQuery } from '@tanstack/react-query';
import { getModuleStatuses, getProperty } from './requests';
import { useAppContext } from '@common/contexts/AppContext';

export const propertiesKeys = {
  properties: ['properties'] as const,
  property: (id: number) => [...propertiesKeys.properties, id] as const,
  moduleStatuses: ({ siteSlug }: { siteSlug: string }) =>
    [...propertiesKeys.properties, 'module-statuses', { siteSlug }] as const,
};

export function useProperty(id: number) {
  return useQuery({
    queryKey: propertiesKeys.property(id),
    queryFn: () => getProperty(id),
    staleTime: Infinity,
    cacheTime: Infinity,
  });
}

export function usePropertyModules(id: number) {
  return useQuery({
    queryKey: propertiesKeys.property(id),
    queryFn: () => getProperty(id),
    select: (data) => data.modules_excluding_disabled,
  });
}

export function useModuleStatuses() {
  const { siteSlug } = useAppContext();

  const query = useQuery({
    queryKey: propertiesKeys.moduleStatuses({ siteSlug }),
    queryFn: () => getModuleStatuses({ siteSlug }),
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  const data = query.data;

  const isRoomsEnabled = data?.data.roomsEnabled ?? false;
  const isGolfEnabled = data?.data.golfEnabled ?? false;

  return {
    query,
    statuses: {
      isRoomsEnabled,
      isGolfEnabled,
    },
  };
}
